import _ from "lodash";

export function filterResults(results, byWhat, byDirection, resultFilter) {
  
  let re = null;
  let filteredResults = [];

  try {
    re = new RegExp(resultFilter);
    filteredResults = re ? [...results.filter(x => re.test(x.description.toLowerCase()) || (x.sku && re.test(x.sku.toLowerCase())))] : [...results];
  } catch (ex) {
    filteredResults = [...results];
  }

  const direction = byDirection ? 'desc' : 'asc';

  let finalResults = null;

  switch (byWhat) {

    case 'desc':
      finalResults = _.orderBy(results, [function (item) { return item.description.trim() }], [direction]);
      break;
    case 'price':
      finalResults = _.orderBy(filteredResults, [function (item) { return item.price }], [direction]);
      break;
    case 'stock':
      finalResults = _.orderBy(filteredResults, [function (item) { return item.inStock }], [direction]);
      break;
    default:
      finalResults = _.orderBy(filteredResults, [function (item) { return item.descriptionMatch.type }, function (item) { return item.price }], [direction, 'desc']);

  }

  return finalResults;
}